import React from "react";
import Heading from "src/components/Heading";
import RichText from "src/utils/RichText";
import GetAny from "src/utils/GetAny";
import FluidImage from "src/utils/FluidImage";
import ContentLabel from "src/components/ContentLabel";
import DateAndTime from "src/utils/DateAndTime";
import ShortenText from "src/utils/ShortenText";

const FourByTwoGridOnBrandItem = (props) => {
  // We'll use this to check if there are items in the loop, if not, we'll display the "nothing happening" message
  let hasItems = [];

  return (
    <div className="relative w-full h-full overflow-hidden">
      {props.months.map((month, i) => {
        return (
          <div
            className={`relative h-auto ${
              month === props.currentFilter ? "visible" : "invisible !h-0"
            }`}
            key={i}
          >
            <ul
              className={`grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-8 py-8 transition-opacity duration-300 ${
                month === props.currentFilter ? "opacity-100" : "opacity-0"
              }`}
            >
              {GetAny(props.items).map((item) => {
                const month = new Date(
                  item.content.start_time
                ).toLocaleDateString("en-GB", { month: "long" });
                if (
                  month === props.currentFilter ||
                  props.currentFilter === "All"
                ) {
                  hasItems.push(1);
                  return (
                    <li key={item.name} className="relative">
                      <a
                        className="flex flex-col cursor-pointer relative"
                        key={item._uid}
                        href={`/${item.full_slug}`}
                      >
                        <div className="absolute left-0 top-0 z-10">
                          <ContentLabel type={item.content.component} />
                        </div>
                        <div className="relative z-1 cursor-pointer hover:opacity-70 duration-300 block">
                          <FluidImage
                            className="mb-3"
                            image={item.content.thumbnail_image}
                          />
                        </div>
                        <time className="font-body text-[0.6875em] text-[#2E2D2C] leading-4">
                          {item.content.start_time &&
                            item.content.end_time &&
                            DateAndTime(
                              item.content.start_time,
                              item.content.end_time
                            )}
                        </time>
                        <span className="font-body text-[0.6875em] text-[#2E2D2C] leading-4 mb-2">
                          {item.content.price}
                          {item.content.component === 'event' ? ' - Live event' : `${item.content.type ? ` - ${item.content.type}` : ""}` }
                        </span>
                        <Heading size="h4" className="text-darkgre mt-1 mb-2">
                          {item.name}
                        </Heading>
                        <p className="text-xs text-darkgrey prose font-body overflow-ellipsis">
                          <RichText>
                            {ShortenText(item.content.meta.description)}
                          </RichText>
                        </p>
                      </a>
                    </li>
                  );
                } else {
                  hasItems.push(0);
                  return null;
                }
              })}
            </ul>
            {!hasItems.includes(1) && (
              <span className="font-body block -mt-12">
                No events scheduled in {props.currentFilter}!
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FourByTwoGridOnBrandItem;
